// Here we will create dark and light theme variables

export const lightTheme = {

    body:"#2ed3e6",
    text:"#4a0a57",
    fontFamily:"'Source Sans Pro', sans-serif",
    bodyRgba : "252, 246, 244",
    textRgba:"0,0,0",
}

export const DarkTheme = {

    body:"#4a0a57",
    text:"#2ed3e6",
    fontFamily:"'Source Sans Pro', sans-serif",
    textRgba : "252, 246, 244",
    bodyRgba:"0,0,0",
}
